import { useGoalsTranslations } from 'modules/iterableGoals/hooks';
import { DateRangeEmptyState } from 'ui/illustrations';
import { NoDataContainer, NoDataSubTitle, NoDataTitle } from './Styled';

export const NoData = () => {
  const { ct } = useGoalsTranslations();

  return (
    <NoDataContainer data-test="goal-analytics-no-data-message">
      <DateRangeEmptyState />
      <NoDataTitle>{ct('emptyState.dateRange.titleVariant2')}</NoDataTitle>
      <NoDataSubTitle>{ct('emptyState.dateRange.subTitle')}</NoDataSubTitle>
    </NoDataContainer>
  );
};
